<ng-container *ngIf="checklistItems$ | async as checklistItems">
	<app-matter-checklist-empty-state
		*ngIf="!checklistItems.length"
	></app-matter-checklist-empty-state>
	<ng-container *ngIf="completePercentage$ | async as completePercentage">
		<ng-container *ngIf="checklistItems.length">
			<div class="flex flex-col gap-4">
				<div class="flex items-center justify-between">
					<div class="flex items-center gap-2" *ngIf="location === 'overview'">
						<app-icon
							[icon]="ICON.CHECKLIST"
							[testHook]="testHooks.ChecklistIcon"
						></app-icon>
						<p class="text-lg font-bold">{{ (template$ | async)?.title }}</p>
					</div>
					<p *ngIf="location === 'nav'">
						<span class="font-bold">{{ completePercentage }}%</span> complete
					</p>
					<atomic-kebab-options
						*ngIf="location === 'overview'"
						class="-mt-3"
						(onSelect)="onChecklistOptionSelected($event)"
						[itemGroups]="[{ items: checklistKebabOptions }]"
						[testHook]="testHooks.KebabOptions"
					></atomic-kebab-options>
				</div>
				<div>
					<div class="flex items-center justify-between w-full">
						<p *ngIf="location === 'overview'" class="text-base text-grey-dark">
							<span class="font-bold">{{ completePercentage }}%</span> complete
						</p>
						<div
							*ngIf="completePercentage === '100'"
							class="rounded-full mb-1 px-2 py-1 bg-blue-lightest flex items-center gap-1"
						>
							<app-icon
								[icon]="ICON.CONGRATS"
								class="text-blue"
								[testHook]="testHooks.CongratsIcon"
							></app-icon>
							<p class="text-sm">
								{{ (template$ | async).congratsMessage || 'Nice work!' }}
							</p>
						</div>
					</div>
					<div class="w-full bg-grey-lighter h-2 rounded-xl relative">
						<div
							[style.width]="completePercentage + '%'"
							class="bg-green absolute left-0 h-2 rounded-xl transition-all ease-in-out duration-300"
						></div>
					</div>
				</div>
				<div
					id="stages-container"
					cdkDropList
					[cdkDropListData]="sortedStages$ | async"
					(cdkDropListDropped)="dropStage($event)"
					class="min-h-[10px]"
				>
					<div
						*ngFor="
							let stage of sortedStages$ | async;
							let i = index;
							trackBy: trackByFunction
						"
						cdkDrag
					>
						<app-matter-checklist-stage [stage]="stage" [location]="location">
							<app-icon
								[icon]="ICON.SORT"
								class="cursor-pointer text-grey-dark"
								cdkDragHandle
								[testHook]="testHooks.SortIcon"
							></app-icon>
						</app-matter-checklist-stage>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
